import { useEffect, useState } from "react";
import { Paper, Button, Table, TableBody, Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { useSnackbar } from "notistack";
import { DeletePopUp, PageLoader, Pagination, STableLoader } from "../../../../shared_elements";
import NoRecordFound from "../../../../shared_elements/NoRecordFound";
import { checkApiStatus } from "../../../../utils";
import { PermissionWrapper } from "../../../../wrappers";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import { ButtonLoader } from "../../../../shared_elements/components";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { trackActivity } from "../../../../utils/mixpanel";
import ModuleWiseRevisionHistory from "../../../../shared_elements/components/ModuleWiseRevisionHistory";
import SettingPageLayout from "../../../elements/SettingPageLayout";
import { RoleBaseAccess } from "../../../../hoc";
import AdditionalTaxTypeCRU from "../Components/AdditionalTaxTypeCRU";
import { globalDeleteService, globalGetService } from "../../../../utils/globalApiServices";
import { deleteAdditionalTaxTypeApi, getAdditionalTaxTypeApi } from "../apiServices";
import AdditionTaxTypeList from "../Components/AdditionTaxTypeList";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const AdditionalTaxTypeHD = ({ createSortHandler, sortInfo, toggleBulkOps, item, bulk }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Additional Tax Type`, page_type: page_type, })
    }
    const tableSorting = (key, name) => {
        return (
            <TableSortLabel active={sortInfo.sort_by === key ? true : false} direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'} onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }} > {name} </TableSortLabel>
        )
    }

    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "additional_tax", operationType: ['D'] }}>
                        <Checkbox color="primary" size="small" onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
                    </PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell sx={{ minWidth: "100px", whiteSpace: "nowrap" }}>{tableSorting('name', 'Name')}</TableCell>
                <TableCell sx={{ minWidth: "100px", whiteSpace: "nowrap" }}>Type</TableCell>
                <TableCell sx={{ minWidth: "100px", whiteSpace: "nowrap" }}>{tableSorting('remarks', 'Remarks')}</TableCell>
            </TableRow>
        </TableHead>
    )
}

const AdditionalTaxType = () => {
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [additionalTaxTypeInfo, setAdditionalTaxTypeInfo] = useState({ list: [], pagination: {} });
    const [additionalTaxTypeCRU, setAdditionalTaxTypeCRU] = useState({ modal: false, data: null, mode: '' });
    const [deleteAdditionalTaxType, setDeleteAdditionalTaxType] = useState({ modal: false, data: null, })
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [isExport, setIsExport] = useState(false);

    useEffect(() => {
        getAdditionalTaxTypeData('skeletonLoader', { per_page: 50 });
        trackActivity('Page Viewed', { page_title: 'Additional Tax Type' })
    }, []);

    const getAdditionalTaxTypeData = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getAdditionalTaxTypeApi(query))
            .then(response => {
                if (checkApiStatus(response)) {
                    setAdditionalTaxTypeInfo(response.data.data);
                    loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                }
            })
    }

    const deleteClauseFn = () => {
        setLoading(true);
        const idsToDelete = deleteAdditionalTaxType?.modal && deleteAdditionalTaxType?.data?.id ? [deleteAdditionalTaxType?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        globalDeleteService(deleteAdditionalTaxTypeApi(), { ids: idsToDelete })
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteAdditionalTaxType({ modal: false, data: null });
                    getAdditionalTaxTypeData('pageLoader', { per_page: additionalTaxTypeInfo?.pagination?.per_page });
                    setBulk({ modal: false, ids: [], title: '', type: '' })
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Additional Tax Type`, success_msg: response?.data?.message, item_ids: deleteAdditionalTaxType?.data || bulk?.ids, response: response?.data })
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Additional Tax Type`, error_msg: response?.data?.message, item_ids: deleteAdditionalTaxType?.data || bulk?.ids, response: response?.data })
                }
            })
    }

    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key };
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        getAdditionalTaxTypeData('pageLoader', { ...sortQuery, per_page: additionalTaxTypeInfo?.pagination?.per_page });
    }

    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
        }
    }

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Additional Tax Type`, page_type: page_type, })
    }

    const handleExport = () => {
        let query = { export: true }
        if (sortInfo?.sort && sortInfo?.sort_by) {
            query = {
                ...query,
                sort: sortInfo?.sort,
                sort_by: sortInfo?.sort_by
            }
        }
        setIsExport(true);
        globalGetService(getAdditionalTaxTypeApi(query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(response?.data.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
            }
            setIsExport(false);
        })
    }

    return (
        <SettingPageLayout
            actionBar={
                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '5px 0px' }}>
                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: "", type: "global" } })} /> </li>
                    {bulk?.type && bulk?.ids?.length > 0 ?
                        <>
                            <li className='lease-mobile-button'>
                                <Button size="small" variant="outlined" color="primary" onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Cancel Button') }}>Cancel</Button>
                            </li>
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "additional_tax", operationType: ['D'] }}>
                                <li className='lease-mobile-button'>
                                    <Button variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057", }} onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Delete Button') }}>{`Delete (${bulk?.ids?.length})`}</Button>
                                </li>
                            </PermissionWrapper>
                        </> : null}
                    {additionalTaxTypeInfo?.list?.length > 0 ?
                        <li className='lease-mobile-button'> <Button variant="outlined" size='small' onClick={() => { handleExport(); handleItemClicked('Export Button') }} startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />}> Export </Button> </li> : null}
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "additional_tax", operationType: ['C'] }}>
                        <li className='lease-mobile-button'>
                            <Button startIcon={<AddOutlinedIcon />} variant="contained" color="primary" size='small' className='btn-primary' onClick={() => { setAdditionalTaxTypeCRU({ modal: true, data: null, mode: 'add' }); handleItemClicked('Add Item Button') }}> Add Additional Tax Type </Button>
                        </li>
                    </PermissionWrapper>
                </ul>
            }
        >
            <Paper className="lease-detail-table table-container lease-module-paper" elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(100vh - 138px)', height: additionalTaxTypeInfo?.list?.length > 0 ? 'calc(100vh - 138px) !important' : 'auto !important' }}>
                <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                    {skeletonLoader ? <STableLoader count={4} rowCount={12} /> : (
                        <Table className='mui-table-format' stickyHeader>
                            <AdditionalTaxTypeHD item={additionalTaxTypeInfo?.list} bulk={bulk} toggleBulkOps={toggleBulkOps} sortInfo={sortInfo} createSortHandler={createSortHandler} />
                            <TableBody>
                                {additionalTaxTypeInfo?.list?.length > 0 && additionalTaxTypeInfo?.list?.map((item, index) => {
                                    return (
                                        <AdditionTaxTypeList
                                            key={index}
                                            item={item}
                                            bulk={bulk}
                                            onEditFn={() => setAdditionalTaxTypeCRU({ modal: true, data: item, mode: 'edit' })}
                                            onView={() => setAdditionalTaxTypeCRU({ modal: true, data: item, mode: 'view' })}
                                            toggleBulkOps={toggleBulkOps}
                                            ondeleteAdditionalTaxType={() => {
                                                setDeleteAdditionalTaxType({ modal: true, data: item, });
                                                setBulk({ modal: false, ids: [item], title: '', type: '' });
                                                handleItemClicked('Delete Item Button');
                                            }}
                                            viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                        />
                                    );
                                })}
                            </TableBody>
                        </Table>
                    )}
                    {!skeletonLoader && additionalTaxTypeInfo?.list?.length === 0 && <NoRecordFound />}
                </div>
                <Paper square>
                    <Pagination
                        pagination={additionalTaxTypeInfo?.pagination}
                        onPageChange={(event, newPage) => { const pageNum = newPage + 1; getAdditionalTaxTypeData("pageLoader", { page: pageNum, per_page: additionalTaxTypeInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                        onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getAdditionalTaxTypeData("pageLoader", { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                    />
                </Paper>
            </Paper>
            {additionalTaxTypeCRU?.modal &&
                <AdditionalTaxTypeCRU additionalTaxTypeCRU={additionalTaxTypeCRU}
                    modeType={additionalTaxTypeCRU?.mode}
                    getResponseBack={() => {getAdditionalTaxTypeData('pageLoader', { per_page: additionalTaxTypeInfo?.pagination?.per_page }); setBulk({modal: false, ids: [], title: '', type: ''})}}
                    onToggleModal={() => setAdditionalTaxTypeCRU({ modal: false, data: null, mode: '' })}
                />}

            {deleteAdditionalTaxType.modal || bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal ? bulk.modal : deleteAdditionalTaxType.modal}
                    title={bulk?.modal ? (bulk?.ids?.length > 0 && bulk?.ids?.length === (additionalTaxTypeInfo?.list?.length || 0)) ? "Delete All Additional Tax Types" : "Delete Selected Additional Tax Type" : "Delete Additional Tax Type"}
                    content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                    onToggleModal={() => bulk.modal ? setBulk({ modal: false, ids: [], title: '', type: '' }) : (setDeleteAdditionalTaxType({ modal: false, data: null }), setBulk({ modal: false, ids: [], title: '', type: '' }))}
                    onDeleteRecords={() => deleteClauseFn()}
                /> : null}

            {revisionHistory.modal &&
                <RevisionHistory
                    moduleName={"additional_tax_type"}
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                />
            }
            {isLoading ? <PageLoader /> : null}
        </SettingPageLayout>
    )
};
export default RoleBaseAccess(AdditionalTaxType, { application: 'lease_revamp', feature: 'additional_tax', operationType: ['R'], settingNav: true });